export const PARAMS = {
  passwordReset: {
    token: 'token',
  },
  contactDetails: {
    contactId: 'contactId',
  },
  editContact: {
    contactId: 'contactId',
  },
  tagList: {},
  tagDetails: {
    tagId: 'tagId',
  },
  editTag: {
    tagId: 'tagId',
  },
}
